module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/more-topic-1-mobile.5f6b9461.jpg";